import React from "react";
import PricingTeaser from "../components/sections/PricingTeaser";
import CtaBand from "../components/sections/CtaBand";
import { ShieldCheck, LifeBuoy, Lock } from "lucide-react";

const PricingPage = () => (
  <>
    <section className="pt-20 pb-6 bg-cream-100 text-center">
      <div className="max-w-3xl mx-auto px-5">
        <p className="tracking-widest text-coral-300 text-xs font-semibold uppercase">Pricing</p>
        <h1 className="font-serif text-navy-700 text-5xl md:text-6xl mt-4">Choose your <span className="italic">occasion</span></h1>
        <p className="mt-5 text-navy-700/70 text-lg">Pricing is tailored to your event type — select yours below to see the right inclusions.</p>
      </div>
    </section>
    <PricingTeaser />

    <section data-testid="pricing-trust-strip" className="pb-16 bg-cream-200/60">
      <div className="max-w-5xl mx-auto px-5 grid md:grid-cols-3 gap-4">
        <div className="bg-white rounded-2xl soft-shadow p-5 flex items-start gap-3">
          <ShieldCheck className="w-6 h-6 text-coral-400 mt-1 shrink-0" />
          <div>
            <div className="font-semibold text-navy-700">14-day money-back guarantee</div>
            <p className="text-sm text-navy-700/60 mt-1">If your event isn&apos;t magical, we&apos;ll refund every cent — no questions asked.</p>
          </div>
        </div>
        <div className="bg-white rounded-2xl soft-shadow p-5 flex items-start gap-3">
          <LifeBuoy className="w-6 h-6 text-coral-400 mt-1 shrink-0" />
          <div>
            <div className="font-semibold text-navy-700">7-day real customer care</div>
            <p className="text-sm text-navy-700/60 mt-1">Actual humans answer support — including weekends and event nights.</p>
          </div>
        </div>
        <div className="bg-white rounded-2xl soft-shadow p-5 flex items-start gap-3">
          <Lock className="w-6 h-6 text-coral-400 mt-1 shrink-0" />
          <div>
            <div className="font-semibold text-navy-700">Enterprise-grade security</div>
            <p className="text-sm text-navy-700/60 mt-1">Encrypted at rest &amp; in transit. 100% of the copyright always stays with you.</p>
          </div>
        </div>
      </div>
    </section>

    <CtaBand />
  </>
);

export default PricingPage;
